import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Form, Button, message, Alert } from "antd";

import { req_edit_lrs_spaceInformation } from "../../api";
import storageUtils from "../../utils/storageUtils";
import RichTextEditor from "./rich-text-editor";

class SpaceModalDescription extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    space: {},
    desription: null,
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.editor = React.createRef();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (condition, item) => {
    item.condition = condition;
    //console.log(item);
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (value) => {
    const { space } = this.props;
    const recordDescription = this.editor.current.output_text();
    const item = {
      Uid: space.Uid,
      recordDescription: recordDescription,
    };
    //console.log(item);
    this.api_modify_item("DESCRIPTION", item);
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { space } = this.props;
    const { RoomCode, RoomTwName } = this.props.space;
    //console.log(space);
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              ({RoomCode}){RoomTwName}
            </div>
          }
          type="success"
        />
        <Form onFinish={this.onFinish} onFinishFailed={this.onFinishFailed}>
          <Form.Item name="RecordDescription">
            <RichTextEditor
              ref={this.editor}
              edit_input_richtext={space.RecordDescription}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {"更新"}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalDescription);
